export { default as CurrencyDollarAltOutlineIcon } from './CurrencyDollarAltOutlineIcon';
